module.exports = __webpack_public_path__ + "img/bg-masthead.063784a2.jpg";